import { observer } from "mobx-react-lite";
import useBreakpoint from 'use-breakpoint'
import { Space, Button, Input, Flex, Radio, RadioChangeEvent, App, Spin, Result, Row, Col } from 'antd';
import Title from "antd/es/typography/Title";
import { useEffect, useState } from "react";
import { useStore } from "../../root-store-context";


export type EStatementsSettings = {
    contactKey: string;
    email: string;
    isSendEmail: boolean;
}

const EStatements = observer(() => {
    const { message } = App.useApp();

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [eStatementsSettings, setEStatementsSettings] = useState<EStatementsSettings>({} as EStatementsSettings);
    const [isValidemail, setValidEmail] = useState<boolean>(true);
    const [isActive, setIsActive] = useState<boolean>(true);
    const { apiStore } = useStore();
    const BREAKPOINTS = { mobile: 0, desktop: 768 }
    const { breakpoint } = useBreakpoint(BREAKPOINTS, 'mobile')

    useEffect(() => {
        setIsLoading(true);
        setEStatementsSettings({ email: apiStore.configApi.userEmail, isSendEmail: false } as EStatementsSettings)
        apiStore.AccountSummaryApiClient.getEStatements().then(async res => {
            if (res !== null) {
                setEStatementsSettings(res);
            }else{
                setIsActive(false);
            }
            setIsLoading(false);
        })
    }, [])

    const onChangeStatement = (e: RadioChangeEvent) => {
        setEStatementsSettings((prev) => {
            return {
                ...prev,
                isSendEmail: e.target.value
            }
        })
    };

    const updateStatements = async () => {
        message.open({
            type: 'loading',
            content: 'Saving...',
            key: 'Saving'
        });
        await apiStore.AccountSummaryApiClient.updateStatements(eStatementsSettings).then(() => {
            message.destroy("Saving");
            message.open({
                type: 'success',
                content: 'Saved',
            });
        }).catch(() => {
            message.destroy("Saving");
            message.open({
                type: 'error',
                content: 'Sorry, no data for this user. Please contact your Community Manager.',
            });
        });
    }

    if (!isActive) {
        return <Result status="404" title="Sorry, no data for this user. Please contact your Community Manager." />
    }

    return <>
    

        <Spin spinning={isLoading}>
        <Row>
          <Col
            xxl={{ span: 12, offset: 6 }}
            xl={{ span: 16, offset: 4 }}
            lg={{ span: 24, offset: 0 }}
            xs={{ span: 24, offset: 0 }}
          >

<Flex align="center" wrap="wrap" justify="space-between">
              <Space style={{ flex: "1 1 400px" }}>
                <Title level={2} style={{ marginTop: "10px" }}>
                Manage Your eCommunication Preferences
                </Title>
                
              </Space>
        </Flex>
            <Flex vertical gap={"middle"}>
                <div>Use this page to opt in to electronic communication (where available) and to update the email address where you would like to receive these messages.</div>
                <div>To make changes, select your preferred delivery method below.</div>
                <div>Please note that updating the email address here will also update the primary contact’s email on your account, which may belong to another individual.</div>
                <div>Copies of your electronic communications are also available in All Access under the Mail Archive section.</div>
                <Input style={{ maxWidth: 450 }} type="email" pattern="^[^@\s]+@[^@\s]+\.[^@\s]+$" value={eStatementsSettings.email} status={!isValidemail ? "error" : ""} onChange={(event) => {
                    setValidEmail(event.target.checkValidity())
                    setEStatementsSettings((prev) => {
                        return {
                            ...prev,
                            email: event.target.value
                        }
                    })
                }} />
                <Radio.Group onChange={onChangeStatement} value={eStatementsSettings?.isSendEmail} >
                    <Space direction="vertical" size={"middle"}>
                        <Radio value={false}>{"Paper statement \n(Send my statement for this account via mail)"}</Radio>
                        <Radio value={true}>{"Electronic statement \n(Send my statement for this account via email)"}</Radio>
                    </Space>
                </Radio.Group>
                <Space style={{ flex: "1 1", justifyContent: "flex-end" }}>
                <Button disabled={!isValidemail} size="middle" type="primary" style={{ width: 300, alignSelf: "center", marginTop: 20 }}
                    onClick={updateStatements}>UPDATE PREFERENCES</Button>
                </Space>
                
            </Flex>
            </Col></Row>
        </Spin>
                
    </>
})

export default EStatements;